export default __webpack_public_path__ + "static/media/marker.deb8f639.svg";